import { useEffect } from 'react';
import { Form, Modal } from 'antd';
import { useCompleteInquiryMutation } from '@/services/parent-api';
import { useGetInquiryCompletedReasonsQuery } from '@/services/general-api';
import Select from '@/components/select';

const CompleteModal = ({ parentId, inquiryId, refetch, onClose }) => {
  const { data: reasonData, isLoading: loadingReasonData } = useGetInquiryCompletedReasonsQuery();
  const [completeInquiry, { isLoading: saving }] = useCompleteInquiryMutation();
  const [form] = Form.useForm();

  useEffect(() => {
    if (inquiryId) {
      setTimeout(() => {
        form.resetFields();
      });
    }
  }, [inquiryId, form]);

  const onFinish = async ({ reasonId }) => {
    try {
      await completeInquiry({ parentId, inquiryId, reasonId }).unwrap();

      refetch();
      onClose();
    } catch (err) {}
  };

  return (
    <Modal
      title="Complete Inquiry"
      open={!!inquiryId}
      confirmLoading={saving}
      okText="Complete"
      onOk={() => form.submit()}
      onCancel={onClose}
    >
      <Form layout="vertical" form={form} onFinish={onFinish}>
        <Form.Item name="reasonId" label="Reason" rules={[{ required: true }]}>
          <Select options={reasonData} loading={loadingReasonData} showSearch />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CompleteModal;
